import { render, staticRenderFns } from "./ItsOrderHaulage.vue?vue&type=template&id=2aa2f2ab&scoped=true&"
import script from "./ItsOrderHaulage.vue?vue&type=script&lang=js&"
export * from "./ItsOrderHaulage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa2f2ab",
  null
  
)

export default component.exports